import { Button, ButtonTypes } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

export interface QuoteButtonProps {
  onPress: () => void;
  hasQuote: boolean;
  isDisabled?: boolean;
  noQuoteText?: string;
  withQuoteText?: string;
  customProps?: Partial<ButtonTypes.CompositeProps>;
}

export const QuoteButton: React.FC<QuoteButtonProps> = ({
  hasQuote,
  isDisabled,
  onPress,
  noQuoteText = 'RESGATAR',
  withQuoteText = 'VER COTAÇÃO',
  customProps,
}) => {
  return (
    <Button
      alignSelf="center"
      color="brand.tertiary.principal"
      variant="textLink"
      onPress={onPress}
      isDisabled={isDisabled}
      _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}
      {...customProps}>
      {hasQuote ? withQuoteText : noQuoteText}
    </Button>
  );
};
